import { MdClose as Close } from 'react-icons/md';
import {
  Dialog,
  DialogContent,
  DialogProps,
  IconButton,
  Theme,
  Typography,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FC } from 'react';
import { ReactComponent as OxLogo } from '../../assets/icons/ox-logo.svg';
import { important } from 'common-types';
import ModalConfirmationDialog from '../../common/components/ModalConfirmationDialog';
import backgroundImage from '../../assets/images/onboarding-background.jpg';

const OnboardingDialog: FC<React.PropsWithChildren<OnboardingDialogProps>> = ({
  header,
  onClose,
  showSkipOnBoarding,
  children,
  closeIcon,
  isSkipOnboardingOpen,
  handleSkipOnboarding,
  closeSkipOnboarding,
  ...dialogProps
}) => {
  const { classes } = useStyles();

  return (
    <Dialog
      fullWidth
      aria-labelledby='modal-dialog'
      PaperProps={{ style: { borderRadius: '15px' } }}
      onClose={onClose}
      scroll='body'
      BackdropProps={{
        style: {
          backgroundImage: `url("${backgroundImage}")`,
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundColor: '#cccccc',
        },
      }}
      {...dialogProps}>
      <div id='onboarding-modal' className={classes.login}>
        {closeIcon && (
          <IconButton
            className={classes.closeIconButton}
            onClick={showSkipOnBoarding}>
            <Close className={classes.closeIcon} />
          </IconButton>
        )}
        <OxLogo className={classes.oxLogo} />
        <Typography
          variant='body1'
          color='text.primary'
          mt={2}
          className={classes.header}>
          {header}
        </Typography>
        <DialogContent>{children}</DialogContent>
      </div>
      <ModalConfirmationDialog
        onConfirmation={handleSkipOnboarding}
        onCloseConfirmationModal={closeSkipOnboarding}
        isOpen={!!isSkipOnboardingOpen}
        title='Are you sure you want to quit onboarding?'
        dialogBody='Are you sure you want to skip onboarding and move directly to the
        product?'
        confirmationButtonText='SKIP'
        cancelButtonText='BACK'
      />
    </Dialog>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  login: {
    padding: theme.spacing(0, 2),
    textAlign: 'center',
  },
  header: {
    marginBlockStart: theme.spacing(2),
    fontWeight: 300,
  },
  oxLogo: {
    marginBlockStart: theme.spacing(4),
    maxWidth: 367,
    color: theme.palette.onboarding.oxLogo.color,
  },
  closeIcon: {
    color: theme.palette.text.primary,
    alignItems: 'right',
    opacity: '30%',
  },
  closeIconButton: {
    right: theme.spacing(1.5),
    top: theme.spacing(1),
    position: important('absolute'),
  },
}));

interface OnboardingDialogProps extends DialogProps {
  header?: string;
  open: boolean;
  onClose?: () => void;
  showSkipOnBoarding?: () => void;
  closeIcon?: boolean;
  isSkipOnboardingOpen?: boolean;
  handleSkipOnboarding?: () => void;
  closeSkipOnboarding?: () => void;
}

export default OnboardingDialog;
